import { Divider, Image, Space, Typography } from "antd";

import { CustomTextField } from "~/components";
import { GETDBFileObj } from "~/types";

import * as APITypes from "~/API";
import { useAppTranslation } from "~/hooks/useAppTranslation";

/**
 * PhotoProvider Docs: https://react-photo-view.vercel.app/en-US/docs/api
 */

export const AmenityDetailsTab = ({
  amenityDetails,
  fileList,
  buildingName,
}: {
  amenityDetails: APITypes.Amenity;
  fileList: GETDBFileObj[];
  buildingName: string;
}) => {
  const { t } = useAppTranslation();
  return (
    <>
      {/* TODO: CS - image url is for manager side; awaiting images on S3 or similar */}
      {fileList.length > 0 && (
        <>
          <Image.PreviewGroup>
            {fileList.map((file) => (
              <Image
                src={file.url}
                width={200}
                style={{
                  objectFit: "cover",
                  width: 200,
                  height: 200,
                }}
              />
            ))}
          </Image.PreviewGroup>
          <br />
        </>
      )}

      <div style={{ marginTop: fileList.length > 0 ? "2rem" : "1rem" }}>
        <Space direction="vertical">
          <Typography.Text strong style={{ marginBottom: 5 }}>
            {t("Description")}
          </Typography.Text>
          <CustomTextField value={amenityDetails.description || ""} />
        </Space>
        <br />
        <Space direction="vertical" style={{ marginTop: "1rem" }}>
          <Typography.Text strong style={{ marginBottom: 5 }}>
            {t("Rules")}
          </Typography.Text>
          {amenityDetails.rules?.split("\n").map((value) => {
            return <CustomTextField value={value || ""} />;
          }) ?? <CustomTextField value={amenityDetails.rules || ""} />}
        </Space>

        <Divider />
        <Typography.Title level={5}>
          {t("Location_Information")}
        </Typography.Title>
        <Space direction="vertical">
          <Typography.Text strong style={{ marginBottom: 5 }}>
            {t("Description")}
          </Typography.Text>
          <CustomTextField value={amenityDetails.locationDescription || ""} />
        </Space>
        <br />
        <Space direction="vertical" style={{ marginTop: "1rem" }}>
          <Typography.Text strong style={{ marginBottom: 5 }}>
            {t("Building")}
          </Typography.Text>
          <CustomTextField value={buildingName} />
        </Space>
        {/* TODO: display map location */}
        {/* <Space direction="vertical">
          <Typography.Text strong style={{ marginBottom: 5 }}>
            {"Geolocation"}
          </Typography.Text>
          <CustomTextField value={amenityDetails.geolocation || ""}/>
        </Space> */}
      </div>
    </>
  );
};
